import { ChipsideComponent } from "../chipside-component";

export class Card extends ChipsideComponent {
	constructor() {
		super();

		this.heading = {
			text: this.getAttribute("heading"),
			size: this.getAttribute("heading-size"),
			subtitle: this.getAttribute("subtitle")
		};

		this.flush = this.hasAttribute("flush");
		this.variation = this.getAttribute("variation");
		this.hoverable = this.hasAttribute("hoverable");
		this.size = this.getAttribute("size")?.toLowerCase();

		if (!this.heading.size) {
			this.heading.size = (() => {
				switch (this.size) {
					case "xs": return "5";
					case "sm": return "4";
					case "md": return "2";
					case "lg": return "1";
					case "body": return "body";
					default: return "3";
				}
			})();
		}
	}

	parsedCallback() {
		this.classList.add("card-frame");

		if (this.flush) { this.classList.add("card--flush"); }
		if (this.variation) { this.classList.add(`card-${this.variation}`); }
		if (this.size) { this.classList.add(`card--${this.size}`); }

		const card = document.createElementWithContents("div",
			this.heading.text ?
				`
				<div class="card-header">
					<div class="card-title">${this.heading.text}</div>
					<div class="card-subtitle">${this.heading.subtitle}</div>
				</div>
			`.trim() : document.createElementWithContents("div", this.querySelector("chip-cardheader"), { className: "card-header" })
		);


		if (!card.querySelector("chip-cardheader")) {
			if (!this.heading.text) { card.querySelector(".card-title")?.remove(); }
			else { card.querySelector(".card-title")?.classList.add(`heading--size${this.heading.size}`); }

			if (!this.heading.subtitle) { card.querySelector(".card-subtitle")?.remove(); }

			if (!this.heading.text && !this.heading.subtitle) { card.querySelector(".card-header").remove(); }
		}

		if (this.innerHTML.trim() !== "") {
			card.appendChild(document.createElementWithContents("div", this.childNodes, { className: "card-body" }));
		}

		this.append(...card.childNodes);
	}
}